import aseguradoraGraph from '#app/assets/images/grafico-aseguradoras.svg'
import portalGraph from '#app/assets/images/grafico-portal.svg'
import productoresGraph from '#app/assets/images/grafico-productores.svg'

interface GraphProps {
	variant: 'productores' | 'aseguradoras' | 'portal'
}

export function FunctionalGraph({ variant }: GraphProps) {
	switch (variant) {
		case 'productores':
			return (
				<img
					src={productoresGraph}
					alt="Gráfico funcional para productores"
					className="h-auto w-full"
				/>
			)
		case 'aseguradoras':
			return (
				<img
					src={aseguradoraGraph}
					alt="Gráfico funcional para aseguradoras"
					className="h-auto w-full"
				/>
			)
		case 'portal':
			return (
				<img
					src={portalGraph}
					alt="Gráfico funcional para portal"
					className="h-auto w-full"
				/>
			)
		default:
			return null
	}
}
